import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { DefaultImage, Media, MediaUpload } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { Button, Modal } from "antd"
import { useState } from "react"
import { FooterProps, RenderConfig } from "./RenderConfig"

const ImageCard = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isChooseMedia, setIsChooseMedia] = useState(true)
  const [url, setUrl] = useState(value)
  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: { url: string }) => {
    setUrl(media.url)
    onChange(media.url)
    setIsModalOpen(false)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="Logo URL" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <img
            src={url ? `${ADMIN_API_CONFIG.API_URL}${url}` : DefaultImage}
            alt="Logo"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-3xl font-semibold drop-shadow-md">Change media</span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div className="ml-4 mt-5">
          <Button
            onClick={() => setIsChooseMedia(true)}
            className="mr-2"
            style={{
              backgroundColor: isChooseMedia ? "blue" : "initial",
              color: isChooseMedia ? "white" : "initial",
            }}
          >
            Select Media
          </Button>
          <Button
            onClick={() => setIsChooseMedia(false)}
            style={{
              backgroundColor: !isChooseMedia ? "blue" : "initial",
              color: !isChooseMedia ? "white" : "initial",
            }}
          >
            Upload Media
          </Button>
        </div>

        <div>
          {isChooseMedia ? (
            <Media isOpenModal={true} onSelectMedia={handleSelectMedia} />
          ) : (
            <MediaUpload isOpenModal={true} setChooseMedia={setIsChooseMedia} />
          )}
        </div>
      </Modal>
    </div>
  )
}

export const CaoCaoFooter: ComponentConfig<FooterProps> = {
  label: "CaoCao | Footer",
  fields: {
    url: {
      label: "Logo URL",
      type: "custom",
      render: props => <ImageCard {...props} />,
    },
    logoStyles: {
      label: "Logo Styles",
      type: "object",
      objectFields: {
        width: {
          label: "Width",
          type: "text",
        },
        height: {
          label: "Height",
          type: "text",
        },
        padding: {
          label: "Padding",
          type: "text",
        },
        margin: {
          label: "Margin",
          type: "text",
        },
        objectFit: {
          label: "Object Fit",
          type: "select",
          options: [
            { label: "Cover", value: "cover" },
            { label: "Contain", value: "contain" },
            { label: "Fill", value: "fill" },
            { label: "None", value: "none" },
            { label: "Scale Down", value: "scale-down" },
          ],
        },
      },
    },
    footerContainerStyles: {
      label: "Footer Container Styles",
      type: "object",
      objectFields: {
        backgroundColor: {
          label: "Background Color",
          type: "text",
        },
        display: {
          label: "Display",
          type: "select",
          options: [
            { label: "Flex", value: "flex" },
            { label: "Block", value: "block" },
            { label: "Grid", value: "grid" },
            { label: "Inline", value: "inline" },
          ],
        },
        flexDirection: {
          label: "Flex Direction",
          type: "select",
          options: [
            { label: "Row", value: "row" },
            { label: "Column", value: "column" },
          ],
        },
        gap: {
          label: "Gap",
          type: "text",
        },
        justifyContent: {
          label: "Justify Content",
          type: "select",
          options: [
            { label: "Flex Start", value: "flex-start" },
            { label: "Center", value: "center" },
            { label: "Flex End", value: "flex-end" },
            { label: "Space Between", value: "space-between" },
          ],
        },
        padding: {
          label: "Padding",
          type: "text",
        },
        className: {
          label: "Class Name",
          type: "text",
        },
      },
    },
    footerItemStyles: {
      label: "Footer Item Styles",
      type: "object",
      objectFields: {
        titleColor: {
          label: "Title Color",
          type: "text",
        },
        titleFontSize: {
          label: "Title Font Size",
          type: "text",
        },
        titleFontWeight: {
          label: "Title Font Weight",
          type: "text",
        },
        titleLineHeight: {
          label: "Title Line Height",
          type: "text",
        },
        descriptionColor: {
          label: "Description Color",
          type: "text",
        },
        descriptionFontSize: {
          label: "Description Font Size",
          type: "text",
        },
        descriptionFontWeight: {
          label: "Description Font Weight",
          type: "text",
        },
        descriptionLineHeight: {
          label: "Description Line Height",
          type: "text",
        },
        gap: {
          label: "Gap",
          type: "text",
        },
      },
    },
    footerItems: {
      label: "Footer Items",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        subItems: {
          label: "Description",
          type: "array",
          arrayFields: {
            subItem: {
              label: "Text",
              type: "text",
            },
            url: {
              label: "URL",
              type: "text",
            },
          },
        },
      },
    },
    contactInfo: {
      label: "Contact Info",
      type: "object",
      objectFields: {
        locationIcon: {
          label: "Location Icon",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        address: {
          label: "Address",
          type: "text",
        },
        addressUrl: {
          label: "Address URL (Google Maps)",
          type: "text",
        },
        phoneIcon: {
          label: "Phone Icon",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        phone: {
          label: "Phone",
          type: "text",
        },
        emailIcon: {
          label: "Email Icon",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        email: {
          label: "Email",
          type: "text",
        },
      },
    },
    iconList: {
      label: "Social Icons",
      type: "array",
      arrayFields: {
        icon: {
          label: "Icon",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    copyRightStyle: {
      label: "Copyright Style",
      type: "object",
      objectFields: {
        backgroundColor: {
          label: "Background Color",
          type: "text",
        },
        padding: {
          label: "Padding",
          type: "text",
        },
        opacity: {
          label: "Opacity",
          type: "text",
        },
        color: {
          label: "Text Color",
          type: "text",
        },
        fontSize: {
          label: "Font Size",
          type: "text",
        },
        fontWeight: {
          label: "Font Weight",
          type: "text",
        },
        lineHeight: {
          label: "Line Height",
          type: "text",
        },
      },
    },
    licenceNo: {
      label: "Licence No",
      type: "text",
    },
    copyRight: {
      label: "Copyright Text",
      type: "text",
    },
    styles: {
      label: "Styles",
      type: "object",
      objectFields: {
        desktop: {
          label: "Desktop Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
        mobile: {
          label: "Mobile Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
        tablet: {
          label: "Tablet Styles",
          type: "object",
          objectFields: {
            display: {
              label: "Display",
              type: "select",
              options: [
                { value: "flex", label: "Flex" },
                { value: "block", label: "Block" },
              ],
            },
          },
        },
      },
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    type: "fluid",
    className: "",
    url: "",
    logoStyles: {
      width: "120px",
      height: "40px",
      padding: "0px",
      margin: "0px",
      objectFit: "contain",
    },
    footerContainerStyles: {
      backgroundColor: "#E8F5E8",
      display: "flex",
      flexDirection: "row",
      gap: "0px",
      justifyContent: "space-between",
      padding: "60px 120px",
      className: "",
    },
    footerItemStyles: {
      titleColor: "#2D5A2D",
      titleFontSize: "16px",
      titleFontWeight: "600",
      titleLineHeight: "24px",
      descriptionColor: "#2D5A2D",
      descriptionFontSize: "14px",
      descriptionFontWeight: "400",
      descriptionLineHeight: "20px",
      gap: "12px",
    },
    footerItems: [],
    contactInfo: {
      address: "",
      addressUrl: "",
      phone: "",
      email: "",
    },
    iconList: [],
    copyRightStyle: {
      backgroundColor: "#2D5A2D",
      padding: "16px",
      opacity: "100%",
      color: "#E8F5E8",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
    },
    licenceNo: "Licence No",
    copyRight: "Copyright 2024 © Cào Cào Adventures. All Rights Reserved",
    styles: {},
  },
  ...RenderConfig,
}
